import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Check, Minus, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PLAN_PRICES } from "@/context/BillingContext";

// free: true = included, string = limited (translated note), false = paid only.
const ROWS = [
  { key: "learning", free: true },
  { key: "guides", free: true },
  { key: "glossary", free: true },
  { key: "quizzes", free: "oneQuiz" },
  { key: "scenarios", free: "oneScenario" },
  { key: "workspace", free: false },
  { key: "lab", free: false },
  { key: "certificates", free: false },
];

const Cell = ({ ok, note }) => (
  ok ? <span className="inline-flex flex-col sm:flex-row items-center gap-0.5 sm:gap-1.5 text-green-300 text-sm"><Check size={16} />{note && <span className="text-xs text-slate-300 whitespace-nowrap">{note}</span>}</span>
    : <span className="text-slate-600"><Minus size={16} /></span>
);

export default function FreeVsPaid({ onStart }) {
  const { t } = useTranslation();
  return (
    <section className="max-w-[1400px] mx-auto px-4 sm:px-6 py-14 sm:py-20 w-full" data-testid="landing-plans">
      <div className="max-w-2xl mb-8">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">{t("landing.plans.eyebrow")}</span>
        <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight mt-2">{t("landing.plans.title")}</h2>
        <p className="text-slate-400 mt-3 text-sm sm:text-base">{t("landing.plans.body", { price: PLAN_PRICES.individual })}</p>
      </div>
      <div className="rounded-md border border-white/10 bg-card overflow-hidden">
        <div className="grid grid-cols-[1fr_76px_64px] sm:grid-cols-[1fr_140px_140px] border-b border-white/10 bg-[#0B132B] text-xs font-bold uppercase tracking-[0.15em]">
          <div className="px-4 py-3 text-slate-400">{t("landing.plans.feature")}</div>
          <div className="px-2 py-3 text-center text-slate-200" data-testid="plans-col-free">{t("pricing.plans.free.name")}</div>
          <div className="px-2 py-3 text-center text-primary" data-testid="plans-col-paid">{t("landing.plans.paid")}</div>
        </div>
        {ROWS.map((r) => (
          <div key={r.key} data-testid={`plans-row-${r.key}`} className="grid grid-cols-[1fr_76px_64px] sm:grid-cols-[1fr_140px_140px] items-center border-b border-white/5 last:border-0">
            <div className="px-4 py-3 text-sm text-slate-200">{t(`landing.plans.rows.${r.key}`)}</div>
            <div className="px-2 py-3 flex justify-center"><Cell ok={!!r.free} note={typeof r.free === "string" ? t(`landing.plans.${r.free}`) : null} /></div>
            <div className="px-2 py-3 flex justify-center"><Cell ok /></div>
          </div>
        ))}
      </div>
      <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4">
        <Button data-testid="plans-start-free" onClick={onStart} className="w-full sm:w-auto justify-center bg-primary hover:bg-primary/90 text-white rounded-full h-12 px-7 text-base">
          {t("landing.startFree")} <ArrowRight size={18} className="ml-1.5" />
        </Button>
        <Link to="/pricing" data-testid="plans-compare-link" className="text-sm text-slate-400 hover:text-white text-center sm:text-left">{t("landing.plans.compare")}</Link>
      </div>
    </section>
  );
}
